import { Form } from 'factorial-form'

class LegalEntityForm extends Form {
  constructor(values: object) {
    super(values, {
      legal_name: 'string',
      country: 'string',
      currency: 'string',
    })
  }
}

export default LegalEntityForm
